import { StructureObject } from '../utils/groupStructure';

import { ObjectType, SerializableObjectType } from './fabric';

export const structuralGroupType = 'structuralGroup';
export const clippingMaskType = 'clippingMask';
export const structuralAssetType = 'asset';
export const backgroundType = 'background';
export const pathType = 'path';

export type LayerType =
  | Exclude<SerializableObjectType, ObjectType.Guide>
  | typeof structuralGroupType
  | typeof clippingMaskType
  | typeof structuralAssetType
  | typeof backgroundType
  | typeof pathType;

interface LayerBase {
  id: string;
  key: string;
  title: string;
  type: LayerType;
  hidden: boolean;
  locked: boolean;
  defaultIcon?: LayerIconType;
  className?: string;
  disabled?: boolean;
  hide?: boolean;
  /*
  The id of the parent group if existed.
  Note: the group can be a structural group or an artboard.
   */
  groupId?: string;
  /*
  The id of the artboard when the layer is a direct child of that
   */
  isChildOfArtboardId?: string;
}

export interface ObjectLayer extends LayerBase {
  opacity?: number;
}

interface GroupLayer extends LayerBase {
  meta?: StructureObject['meta'];
  children: LayerOtherThanArtboard[];
}

export interface StructuralGroupLayer extends GroupLayer {
  type: typeof structuralGroupType;
}

export interface ClippingMaskLayer extends GroupLayer {
  type: typeof clippingMaskType;
}

export interface ArtboardLayer extends LayerBase {
  type: ObjectType.Artboard;
  /*
  Whether the artboard layer has a linked texture layer
   */
  hasLinkedTextureLayer: boolean;
  children?: LayerOtherThanArtboard[];
}

type LayerOtherThanArtboard =
  | ObjectLayer
  | StructuralGroupLayer
  | ClippingMaskLayer;

export type Layer =
  | ObjectLayer
  | StructuralGroupLayer
  | ArtboardLayer
  | ClippingMaskLayer;

/**
 * General layer info that has common properties of different layer types.
 *
 * Useful if you don't need all the properties of LayerBase and you don't
 * want to deal with incompatibility of different layer types in a union.
 */
export interface LayerBaseInfo
  extends Pick<
    LayerBase,
    'id' | 'type' | 'hidden' | 'locked' | 'groupId' | 'title' | 'defaultIcon'
  > {
  children?: LayerBaseInfo[];
}

/**
 * Type of icons that can be used for objects defaultIcons property,
 * this is one to one mapping with the icons available in the LayerIcon component.
 */
export type LayerIconType = 'drawIcon';
